import React, { CSSProperties, useCallback } from "react";
import { useTranslation } from "react-i18next";
import IconAddFile from "../dynamicicons/icon-file-add";
import * as styles from "./document-upload-field.module.scss";

interface DocumentUploadFieldProps {
	style?: CSSProperties;
	className?: string;

	onReceive?: (file: File) => void;
}

export default function DocumentUploadField(props: DocumentUploadFieldProps) {
	const { t } = useTranslation();
	const propsOnReceive = props.onReceive;
	const onFileSelect = useCallback(
		(event: React.FormEvent<HTMLInputElement>) => {
			propsOnReceive?.(event.currentTarget.files![0]);
			event.currentTarget.value = "";
		},
		[propsOnReceive],
	);

	const eventPrevent = useCallback((e: React.DragEvent<HTMLLabelElement>) => {
		e.preventDefault();
	}, []);

	const fileDrop = useCallback(
		(e: React.DragEvent<HTMLLabelElement>) => {
			e.preventDefault();
			propsOnReceive?.(e.dataTransfer.files![0]);
		},
		[propsOnReceive],
	);

	return (
		<label
			style={props.style}
			className={`${styles.container} ${props.className}`}
			onDragOver={eventPrevent}
			onDragEnter={eventPrevent}
			onDragLeave={eventPrevent}
			onDrop={fileDrop}
		>
			<IconAddFile />

			<span className={styles.title}>
				{t("elements.document_upload.drag_or_click")}
			</span>
			<span className={styles.subtitle}>
				{t("elements.document_upload.accepted_formats")}
			</span>

			<input
				className={styles.input}
				type="file"
				name="image"
				accept="image/png, image/jpeg, application/pdf"
				onChange={onFileSelect}
			/>
		</label>
	);
}
